<template>
    <div class="groupFields" :class="{ 'onlyView': getPermissionAction }">
        <div class="groupField">
            <div class="groupFieldTitle">
                <span>Accounts</span>
		            <v-btn
				            @click="onAddItem" type="button"
				            depressed
				            class="mainBtn mainBtn-text"
		            >
			            <span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
			            <span class="btnText">Add new account</span>
		            </v-btn>
            </div>
            <template v-for="({ name, url, login, pass }, idx) in accountsList">
                <div class="groupField_wrap" :key="idx">
                    <field
                        :classError="valid.accounts.$each.$iter[idx]['name'].$error"
                        width="330px"
                        margin="0 10px 10px 0"
                        label="Name"
                        placeholder="Enter name"
                        @updateInput="onInput($event, idx, 'name')"
                        :setInputValue="name"
                        is-required
                    ></field>
                    <field
                        :classError="valid.accounts.$each.$iter[idx]['url'].$error"
                        width="330px"
                        margin="0 10px 10px 0"
                        label="URL"
                        placeholder="Enter URL"
                        @updateInput="onInput($event, idx, 'url')"
                        :setInputValue="url"
                        is-required
                        is-clip
                        is-link
                    ></field>
                    <field
                        :classError="valid.accounts.$each.$iter[idx]['login'].$error"
                        width="330px"
                        margin="0 10px 10px 0"
                        label="Login"
                        placeholder="Enter login"
                        @updateInput="onInput($event, idx, 'login')"
                        :setInputValue="login"
                        is-required
                        is-clip
                    ></field>
                    <field
                        :classError="valid.accounts.$each.$iter[idx]['pass'].$error"
                        width="330px"
                        margin="0 10px 10px 0"
                        label="Password"
                        type="password"
                        placeholder="Enter password"
                        @updateInput="onInput($event, idx, 'pass')"
                        :setInputValue="pass"
                        is-required
                        is-pass
                        is-clip
                    ></field>
                    <button type="button" class="deleteItem" @click="onDeleteItem(idx, 'dnuList')">
                        <svg-sprite style="color: #19BC38" width="20" height="20" icon-id="deleteItem"></svg-sprite>
                    </button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "ThirdTab",
	props: {
		valid: Object,
		getPermissionAction: Boolean
	},
	computed: mapGetters([ 'customersList' ]),
	data: () => ({
		accountsList: []
	}),
	methods: {
		onAddItem() {
			const value = {
				access_id: null,
				dicision_id: null,
				login: "",
				name: "",
				pass: "",
				url: ""
			};

			this.accountsList.push(value);
			this.$emit('updateData', { ...this.$data });
		},
		onInput({ value }, idx, key) {
			this.accountsList[idx][key] = value;
			this.$emit('updateData', { ...this.$data });
		},
		onDeleteItem(idx) {
			this.accountsList.splice(idx, 1);
			this.$emit('updateData', { ...this.$data });
		}
	},
	mounted() {
		const { accounts } = this.customersList;
		this.accountsList = accounts;
		this.$emit('updateData', { ...this.$data });
	}
};
</script>

<style scoped lang="scss">
@import "ThirdTab";
</style>
